/**
 * Retailer display helpers.
 *
 * A custom gift (added without a product URL) is stored against a placeholder
 * retailer whose hostname is "custom_item"; the API's name accessor falls back
 * to the hostname, so both fields carry the raw value. Nothing about that
 * retailer should ever reach the UI.
 */
export const CUSTOM_ITEM_RETAILER = "custom_item";

/**
 * Whether the retailer is the custom-item placeholder.
 * @param {object|null|undefined} retailer
 * @return {boolean}
 */
export function isCustomItemRetailer(retailer) {
    if (!retailer) {
        return false;
    }

    return (
        retailer.name === CUSTOM_ITEM_RETAILER ||
        retailer.hostname === CUSTOM_ITEM_RETAILER
    );
}

/**
 * The retailer's hostname without a leading "www.", or null when there is
 * nothing to show (missing retailer, missing hostname, or the custom-item
 * placeholder).
 * @param {object|null|undefined} retailer
 * @return {string|null}
 */
export function retailerHost(retailer) {
    if (isCustomItemRetailer(retailer) || !retailer?.hostname) {
        return null;
    }

    return retailer.hostname.replace(/^www\./, "");
}

/**
 * The retailer's display name, or null when there is nothing to show.
 * @param {object|null|undefined} retailer
 * @return {string|null}
 */
export function retailerDisplayName(retailer) {
    if (isCustomItemRetailer(retailer) || !retailer?.name) {
        return null;
    }

    return retailer.name;
}
